import { render } from "./CartinList.vue?vue&type=template&id=08593fb0&scoped=true"
import script from "./CartinList.vue?vue&type=script&lang=js"
export * from "./CartinList.vue?vue&type=script&lang=js"

import "./CartinList.vue?vue&type=style&index=0&id=08593fb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08593fb0"]])

export default __exports__